import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { faCopy as faSolidCopy } from '@fortawesome/pro-solid-svg-icons';
import { AnalyticsLogResponse } from '@kcftech/prometheus-client';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { tokens } from 'styles/tokens';
import { copyToClipboard } from 'utils/clipboard';

export type AnalyticsLogContentProps = {
    log: AnalyticsLogResponse;
};

export function AnalyticsLogContent({ log }: AnalyticsLogContentProps) {
    return (
        <div className="flex-row p-10 justify-between">
            <div className="flex-grow-1">
                {log.Message}
                <HoverIconButton
                    icon={faCopy}
                    hoverIcon={faSolidCopy}
                    color={tokens.text.secondary}
                    onClick={() => copyToClipboard(log.Message)}
                />
            </div>
        </div>
    );
}
